<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">服务录音设置</div>
      <el-form-item label="存储空间名称">
        <el-input v-model="form.bucket" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="ACCESS_KEY">
        <el-input v-model="form.access_key" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="SECRET_KEY">
        <el-input v-model="form.secret_key" type="password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="空间域名">
        <el-input v-model="form.domain" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>

</template>

<script>
import SettingApi from "@/api/setting.js";

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        bucket: "", //bucket
        access_key: "",
        secret_key: "", //secret_key
        domain: ""
        // is_open: "0"
      },
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.getRecord({}, true)
        .then(data => {
          // let vars = data.data.vars.values.engine.qinqiu;
          self.form = data.data.vars.values.engine.qiniu;
          console.log(
            "==========",
            self.form,
            data.data.vars.values.engine.qiniu
          );
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editRecord(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，设置成功",
            type: "success"
          });
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/soundrecord/index.vue